import { render, staticRenderFns } from "./DfCheckboxField.vue?vue&type=template&id=1af825b2&scoped=true&"
import script from "./DfCheckboxField.vue?vue&type=script&lang=js&"
export * from "./DfCheckboxField.vue?vue&type=script&lang=js&"
import style0 from "./DfCheckboxField.vue?vue&type=style&index=0&id=1af825b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af825b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af825b2')) {
      api.createRecord('1af825b2', component.options)
    } else {
      api.reload('1af825b2', component.options)
    }
    module.hot.accept("./DfCheckboxField.vue?vue&type=template&id=1af825b2&scoped=true&", function () {
      api.rerender('1af825b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/fields/DfCheckboxField.vue"
export default component.exports